import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_HOUSEHOLD_SUBMIT_APPLICATION } from 'api/actionTypes';

import submitRenterProfileAction from 'client/actions/Household/submitRenterProfile';
import getHouseholdApplicationsAction from 'client/actions/Household/getApplications';

export default async function submitHouseholdApplication({ state, apiClient }, params) {
  const { userId, listingId, householdApplication } = params;

  typeCheck('userId::PositiveNumber', userId);
  typeCheck('listingId::PositiveNumber', listingId);
  typeCheck('householdApplication::NonEmptyObject', householdApplication);

  await submitRenterProfileAction({ state, apiClient }, params);

  const submitApplicationResult = await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_SUBMIT_APPLICATION,
    queryId: String(listingId),
    state: state,
    payload: {
      userId,
      listingId,
      householdApplication,
    },
  });

  await getHouseholdApplicationsAction(
    { state, apiClient },
    {
      userId: userId,
    },
  );

  return submitApplicationResult;
}
